<template>
    <section>
        <div class="free_flex">
            <div class="left_flex for_desktop">
                <img width="545" height="440" src="~/assets/free-product/stud.png" alt="">
            </div>
            <div class="center_flex">
                <div>
                    <h3>Diamonds On Us!</h3>
                    <p class="mb-1 for_desktop">Free 1/2 carat gold Solitaire Necklace on a spend of $3000 or more.</p>
                    <p class="mb-0 for_desktop">Free 1 carat gold Stud Earrings on a spend of $5000 or more.</p>
                    <p class="for_mobile">Free Diamond Jewelry On Purchases Over $3000!</p>
                </div>
            </div>
            <div class="right_flex">
                <img width="545" height="440" src="~/assets/free-product/pendant.png" alt="">
                <img class="for_mobile" width="545" height="440" src="~/assets/free-product/stud.png" alt="">
            </div>
        </div>

        <div class="free_popup_block">
            <div class="popup_btn" @click="showModal">See Terms & Conditions</div>
            <div v-if="flagShowModal">
                <Teleport  to="#teleports">
                    <div class="modal fade" data-bs-backdrop="true" id="modalTall" tabindex="-1" aria-labelledby="modalTallLabel" aria-hidden="true" ref="myModalRef">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content model_block">    
                                <div class="modal-body">
                                    <div class="title_block">
                                        <div>
                                            <h5 class="mb-0 font-active">Terms & Conditions</h5>
                                        </div>
                                        <span data-bs-dismiss="modal"><SvgHeaderSvg :type="'close'" class="largesvg" /></span>
                                    </div>
                                    <div class="modal_body">
                                        <FreeProductTerms />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Teleport>
            </div>
        </div>
        
    </section>
</template>

<script setup>
    import { useModalCleanup } from '~/composables/useModalCleanup';
    
    const flagShowModal = ref(false);
    const myModalRef = ref(null);
    

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
            const modalElement = myModalRef.value;
            if (modalElement) {
                const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
                // modalInstance.on('hidden.bs.modal', function (e) {
                    
                //     console.log('model is hidden', )
                // })
            }
        });

    };


    const hideModal = () => {
        const modalElement = myModalRef.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };


    onMounted( () => {

        const modalElement = myModalRef.value;
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
    })

    useModalCleanup(['modalTall']);


</script>


<style scoped>
/* Two Changes done .modal-header, modal-body & color to h5 */
section {
    background: url('../../assets/free-product/black_friday/banner.jpg');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
}
.free_flex {
    display: flex;
    justify-content: space-around;
    padding: 0 15%;
}

.left_flex {
    width: 20%;
}

.right_flex {
    width: 20%;
}

.center_flex {
    width: 60%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
h3 {
    font-size: 40px;
    color: #fee4b3;
    text-transform: uppercase;
    letter-spacing: 5px;
}

p {
    color: #fff;
    font-size: 18px;
}
p span {
    font-weight: 600;
}
.free_popup_block {
    position: absolute;
    bottom: 10px;
    right: 16px;
    color: #fff;
    font-size: 14px;
    text-decoration: underline;
}

.popup_btn {
    cursor: pointer;
}

/* ---------------- */
.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.modal_body p {
    font-size: 14px;
    margin-bottom: 0;
    padding-top: 9px;
    color: #6a6161;
}

.title_block span {
    cursor: pointer;
}
.modal_body p span {
    font-weight: 600;
    color: #212529;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}
h5{
    font-size: 24px;
    text-align: center;
    color: #212529;
}

.largesvg {
    transform: scale(1.3);
    }

.modal-content{
    padding: 2%;
}

/* ---------------- */
@media(max-width: 1380px){
    h3{
        font-size: 26px;
    }
    p{
        font-size: 16px;
    }
}

@media(max-width: 1200px){
    .free_flex{
        padding: 0 5%;
    }
    
}

@media(max-width: 992px){
    h3{
        font-size: 20px;
        letter-spacing: 3px;
    }
    p{
        font-size: 14px;
    }
    .free_flex{
        padding: 0 1%;
    }
}
@media(max-width: 767px){
    section {
        background: url('../../assets/free-product/black_friday/banner_mob.jpg');
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        padding: 0 5% 5% 5%;
    }
    .free_flex {
        flex-wrap: wrap;
        flex-direction: column-reverse;
    }

    .left_flex {
        width: 20%;
    }

    .right_flex, .center_flex {
        width: 100%;
    }
    .right_flex{
        display: flex;
    }
    .right_flex img{
        width: 50%;
    }
    h3{
        font-size: 26px;
    }
    p{
        font-size: 16px;
    }
    h5{
        font-size: 16px;
    }
    .free_popup_block {
        position: relative;
        width: 100%;
        text-align: center;
        bottom: 0;
        right: 0;
    }
}
</style>